import { toast } from 'react-toastify';

export function showCopyErrorToast(error?: string) {
  const message = 'Could not copy text';

  if (error) {
    console.debug(`${message}: `, error);
  }

  toast.error(`${message}. Please do it manually`);
}

export function copyToClipboard(text: string): Promise<void> {
  if (!text) {
    return Promise.reject(new Error('No text to copy'));
  }

  if (!navigator.clipboard) {
    showCopyErrorToast('navigator.clipboard is not available');
    return Promise.reject(new Error('Clipboard API not available'));
  }

  return navigator.clipboard.writeText(text).catch((error) => {
    showCopyErrorToast(error);
    return Promise.reject(error);
  });
}
